import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Table, Button } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import UserService, { UserItem } from '#/services/UserService';
import { Pagenate, PagenateData } from './parts/Pagenate';
import * as URI from 'urijs';
import { SpinnerView } from './parts/SpinnerView';
import { PAGE_SIZE } from '#/config/constant';
import { UserContext } from './App';
import { FilterView } from './parts/FilterView';

function Admin() {
  const ctx = useContext(UserContext);
  const service = new UserService(ctx.userInfo!);
  const [admins, setAdmins] = useState<UserItem[]>();
  const uri = new URI.default(window.location.href);
  const [page, setPage] = useState<PagenateData>({
    total: 0,
    page: Number(uri.query(true)['page'] || 0),
    size: PAGE_SIZE,
  });
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setAdmins(undefined);

    service
      .getList({ ...uri.query(true), ...page, group: 'admin' })
      .then((res) => {
        setPage({
          ...page,
          ...res.page,
        });
        setAdmins(res.data);
      }, (e) => {
        if( e?.response.status === 401 ) {
          navigate(0);
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  let items = [<></>];
  if (admins === undefined) {
    items = [
      <tr>
        <td colSpan={8}>
          <SpinnerView />
        </td>
      </tr>,
    ];
  } else if (admins.length > 0) {
    items = admins.map((data: UserItem) => {
      const notify = [
        data.notify.sms ? 'SMS' : '',
        data.notify.email ? 'Mail' : '',
      ];

      return (
        <tr key={data.id}>
          <td>
            <Link to={`/admin/${data.id}`}>{data.id}</Link>
          </td>
          <td>{data.name}</td>
          <td>
            <Link to={`/owner?admin_id=${data.id}`}>
              {data.device_count.owner}
            </Link>
          </td>
          <td>
            <Link to={`/child?admin_id=${data.id}`}>
              {data.device_count.child}
            </Link>
          </td>
          <td>{notify.join(' / ')}</td>
        </tr>
      );
    });
  } else {
    items = [
      <tr>
        <td colSpan={8}>データがありません</td>
      </tr>,
    ];
  }

  return (
    <>
      <header className="page-header page-header-dark bg-gradient-primary-to-secondary pb-10">
        <div className="container-xl px-4">
          <div className="page-header-content pt-1">
            <div className="row align-items-center justify-content-between">
            </div>
          </div>
        </div>
      </header>
      <div className="container-xl px-4 mt-n10">
        <div className="card mb-4">
          <div className="card-body">
            <Row>
              <Col>
                <FilterView name={true} id={true} />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <Pagenate {...page} />
              </Col>
              <Col className="text-end">
                <Button variant="primary" className="w-50" href="/admin/add">
                  登録
                </Button>
              </Col>
            </Row>
            <Row className="mt-3 border">
              <Col className="p-2">
                <Table className="mb-0">
                  <thead>
                    <tr>
                      <th>管理者ID</th>
                      <th>名称</th>
                      <th>親機数</th>
                      <th>子機数</th>
                      <th>お知らせ設定</th>
                    </tr>
                  </thead>
                  <tbody>{items}</tbody>
                </Table>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
}

export default Admin;
